



























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { filterDate } from '~/assets/filters/date'
import MixinGeneral from '~/assets/mixins/general'
import { IAction } from '~/assets/interfaces/actions'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
  },
  filters: {
    filterDate,
  },
})
export default class ComponentActionItem extends mixins(MixinGeneral) {
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IAction

  private mounted(): void {
    this.$emit('loaded')
  }
}
